import FormBuilder from "../../../../components/form-builder/form-builder";
import FormInput from "../../../../components/form-builder/form-input";
import * as Yup from "yup";

// const listObjectives = [
//   {
//     id: "avaliação de necessidade de crédito",
//     label: "Avaliação de necessidade de crédito"
//   },
//   {
//     id: "análise de planejamento de crédito",
//     label: "Análise de planejamento de crédito"
//   },
//   {
//     id: "elaboração de proposta de crédito",
//     label: "Elaboração de proposta de crédito"
//   },
//   {
//     id: "complementação de garantia com o fampe",
//     label: "Complementação de Garantia com o Fampe"
//   },
// ]

const namePlanningValidation = Yup.object().shape({
  title: Yup.string().required("Título é obrigatório"),
  // objective: Yup.string().required("Objetivo é obrigatório"),
  score: Yup.number()
    .typeError("Score deve ser numérico")
    .min(0, "Score deve ser no mínimo 0")
    .max(1000, "Score máximo é 1000")
    .nullable(),
})

const NamePlanning = ({ data,isDisabled, onChange }) => {
  return (
    <div className="step name-planning">
      <FormBuilder
        initialValues={data}
        validationSchema={namePlanningValidation}
      >
        <FormInput
          id="title"
          name="title"
          isDisabled={isDisabled}
          label="Nome do planejamento"
          placeholder="Escolha um nome para esse planejamento"
          subLabel="(Campo obrigatório)"
          onExternalChange={onChange}
          maxLength={40}
        />

        {/*<FormInput*/}
        {/*  id="objective"*/}
        {/*  name="objective"*/}
        {/*  type="select"*/}
        {/*  isDisabled={isDisabled}*/}
        {/*  label="Qual o seu objetivo?"*/}
        {/*  placeholder="Selecione"*/}
        {/*  options={listObjectives}*/}
        {/*  onExternalChange={onChange}*/}
        {/*/>*/}

        <FormInput
          id="score"
          name="score"
          type="number"
          isDisabled={isDisabled}
          label="Deseja compartilhar seu score? "
          placeholder="Compartilhe seu score"
          subLabel="(Opcional)"
          onExternalChange={onChange}
          maxLength={4}
          maxValue={1000}
          showHelpButton
          helpButtonProps={{
            direction: "left",
            alertSize: 252,
            iconProps: {
              color: "#243342",
              size: 16,
            },
            title: "Entenda o que é o Score de Crédito",
            message: (<div dangerouslySetInnerHTML={{ __html: `O score de crédito é uma pontuação que vai de <strong>0 a 1000</strong> e indica a sua reputação como pagador no mercado. Quanto maior o score, maior a chance de conseguir condições melhores de crédito como limites maiores e juros mais baixos. Outros fatores como score dos sócios, quantidade de consultas e contratos financeiros também influenciam essa pontuação.<br /><br />Preencher o seu Score é <strong>opcional</strong>, mas conhecer esse indicador te trará consciência de caminhos que qualifiquem sua situação financeira junto ao mercado de crédito. Para o Sebrae será importante para recomendarmos soluções que te auxiliem no caminho da melhor saúde financeira.<br/><br/>Conhecer a sua pontuação é fácil e gratuito, basta acessar os sites de empresas de proteção ao crédito.`}}></div>),
            type: "popover",
          }}
        />
      </FormBuilder>
    </div>
  )
}

export default NamePlanning
